<template>
    <div class="body-wrapper">
        <a href="https://wa.me/6594363876" target="_blank" class="btn-wa">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48">
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M2.004 22l1.352-4.968A9.954 9.954 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.954 9.954 0 0 1-5.03-1.355L2.004 22zM8.391 7.308a.961.961 0 0 0-.371.1 1.293 1.293 0 0 0-.294.228c-.12.113-.188.211-.261.306A2.729 2.729 0 0 0 6.9 9.62c.002.49.13.967.33 1.413.409.902 1.082 1.857 1.971 2.742.214.213.423.427.648.626a9.448 9.448 0 0 0 3.84 2.046l.569.087c.185.01.37-.004.556-.013a1.99 1.99 0 0 0 .833-.231c.166-.088.244-.132.383-.22 0 0 .043-.028.125-.09.135-.1.218-.171.33-.288.083-.086.155-.187.21-.302.078-.163.156-.474.188-.733.024-.198.017-.306.014-.373-.004-.107-.093-.218-.19-.265l-.582-.261s-.87-.379-1.401-.621a.498.498 0 0 0-.177-.041.482.482 0 0 0-.378.127v-.002c-.005 0-.072.057-.795.933a.35.35 0 0 1-.368.13 1.416 1.416 0 0 1-.191-.066c-.124-.052-.167-.072-.252-.109l-.005-.002a6.01 6.01 0 0 1-1.57-1c-.126-.11-.243-.23-.363-.346a6.296 6.296 0 0 1-1.02-1.268l-.059-.095a.923.923 0 0 1-.102-.205c-.038-.147.061-.265.061-.265s.243-.266.356-.41a4.38 4.38 0 0 0 .263-.373c.118-.19.155-.385.093-.536-.28-.684-.57-1.365-.868-2.041-.059-.134-.234-.23-.393-.249-.054-.006-.108-.012-.162-.016a3.385 3.385 0 0 0-.403.004z" fill="rgba(35,205,100,1)" />
            </svg>
        </a>
        <div class="w-full header-banner">
            <div class="w-full header-bg">
                <div class="w-full header-top">
                    <div class="container px-4 pt-6">
                        <div class="flex w-full pt-4 pb-4">
                            <div class="w-3/6 md:w-4/12 lg:w-4/12">
                                <router-link class="m-auto" to="/"><img class="m-auto md:m-0" src="/images/logo.png" /></router-link>
                            </div>
                            <div class="flex items-center justify-end w-5/6 text-left md:w-6/10 lg:w-7/12">
                                <div class="block pr-0 md:block">
                                    <img class="hidden w-5/6 lg:block" src="/images/tel-icon.png" />
                                    <img class="block w-5/6 lg:hidden" src="/images/tel-icon.png" />
                                </div>
                                <div class="block">
                                    <div class="font-bold text-gray-800 lg:text-2xl">Call us at<br /><a href="tel:+6567471910">(+65) 6747 1910</a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container px-4 pt-0 pb-4 lg:pt-2">
                    <div class="w-full lg:flex section">
                        <div class="w-full text-center lg:w-7/12 md:text-center lg:text-left">
                            <div class="text-5xl font-bold md:text-5xl lg:text-6xl xl:text-6xl lg:text-blue title-text">The Veteran</div>
                            <div class="mb-8 text-2xl font-bold leading-10 text-green-700 lg:text-4xl lg:text-green-600 md:mb-16">
                                <div class="pb-0 text-4xl lg:pb-12 lg:text-5xl xl:text-6xl">
                                    in E-Waste <br class="block" />
                                    <div class="pt-2 lg:pt-4 xl:pt-8">Disposal &amp;</div>
                                    <div class="pt-2 lg:pt-4 xl:pt-8">Recycling</div>
                                </div>
                                <div class="mt-10 text-xl font-semibold text-gray-800 text-shadow-xl lg:text-3xl lg:text-white lg:mt-20">Computers, Laptops,<br class="block" />Hard drives, Monitors,<br class="block" />Printers, etc</div>
                            </div>
                            <div class="hidden w-full pt-2 md:pt-2 lg:block">
                                <img src="/images/header-icon.png" class="md:pt-2" />
                            </div>
                            <div class="block w-full lg:hidden">
                                <img class="m-auto" src="/images/header-img-m.png" />
                            </div>
                        </div>
                        <div class="hidden w-1/12 lg:block"></div>
                        <div id="contact-area" class="w-full m-0 md:w-9/12 lg:w-4/12 md:m-auto">
                            <div class="w-full">
                                <div class="w-full p-8 bg-white">
                                    <div class="w-full mt-5 mb-6 text-3xl font-bold leading-none text-center text-gray-800"><span class="text-2xl lg:text-3xl">Request a</span><br /><span class="text-4xl font-extrabold lg:text-5xl">Free Quote</span></div>
                                    <!-- feedback.activamedia.com.sg script begins here -->
                                    <iframe allowTransparency="true" style="min-height: 620px; height: inherit; overflow: auto" width="100%" id="contactform123" name="contactform123" marginwidth="0" marginheight="0" frameborder="0" src="https://feedback.activamedia.com.sg/my-contact-form-5979529.html">
                                        <p>Your browser does not support iframes. The contact form cannot be displayed. Please use another contact method (phone, fax etc)</p>
                                    </iframe>
                                    <!-- feedback.activamedia.com.sg script ends here -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full mt-12 text-center md:flex">
            <div class="container flex flex-row items-center justify-between px-4 pt-6 mx-auto">
                <div class="w-1/5 lg:w-1/4 md:block title-line"></div>
                <div class="text-4xl font-bold leading-none text-blue-400 w-1/1 md:text-5xl title-text">Our Key Solutions</div>
                <div class="w-1/5 lg:w-1/4 md:block title-line"></div>
            </div>
        </div>
        <div class="w-full pt-10 md:pt-0 lg:pt-12">
            <div class="container flex flex-col px-4 pt-6 mx-auto lg:flex-row">
                <div class="w-full mb-10 lg:mb-0">
                    <div class="pl-0 pr-0 lg:pl-0 lg:pr-8" id="hdb">
                        <div class="block h-auto pt-2 pb-1 text-2xl font-bold text-center text-white bg-blue-400 title-bg-color">ELECTRONIC DISPOSAL</div>
                        <div class="block h-auto pt-3 pb-3 bg-gray-300 lg:pb-10">
                            <ul>
                                <li class="pb-2">Collection of e-waste at your location</li>
                                <li class="pb-2">Safe and Secure disposal service</li>
                                <li class="pb-2">Certification provided for erasure/degauss of assets, if required</li>
                                <li class="pb-2">Dispose accordingly to NEA standards and guidelines</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="w-full mb-10 lg:mb-0">
                    <div class="pl-0 pr-0 lg:pl-0 lg:pr-4" id="condominium">
                        <div class="block h-auto pt-2 pb-1 text-2xl font-bold text-center text-white bg-blue-400 title-bg-color">E-WASTE RECYCLING</div>
                        <div class="block h-auto pt-3 pb-3 bg-gray-300">
                            <ul>
                                <li class="pt-2 pb-2">
                                    <strong>Trade-in of computers and laptops<br />available</strong>
                                </li>
                                <li class="pb-2">Brand protection, and full data wipe</li>
                                <li class="pb-2">Collection of e-waste at your location</li>
                                <li class="pb-6">Recycle in accordance to NEA standards &amp; guidelines</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="w-full mb-10 lg:mb-0">
                    <div class="pl-0 pr-0 lg:pl-4 lg:pr-4" id="landed-interior">
                        <div class="block h-auto pt-2 pb-1 text-2xl font-bold text-center text-white bg-blue-400 title-bg-color">LAPTOP/NOTEBOOK RENTAL</div>
                        <div class="block h-auto pt-3 pb-3 bg-gray-300 lg:pb-10">
                            <ul>
                                <li class="pt-2 pb-2">Good condition equipments</li>
                                <li class="pb-2">Large scale capabilities</li>
                                <li class="pb-2">Fast deployment</li>
                                <li class="pb-3 lg:pb-12">Full set up provided</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full mt-8 lg:mt-12">
            <div class="w-full">
                <div class="w-full mb-12 lg:flex lg:pt-6">
                    <div class="w-full bg-cover lg:w-6/12">
                        <img src="/images/promotion-bg.jpg" class="h-full" width="100%" height="100%" />
                    </div>
                    <div class="w-full lg:w-6/12 lg:pl-12 title-bg-color">
                        <div class="px-4 pt-16 mb-3 text-4xl font-bold leading-none text-white md:text-5xl">What We Can Help You Dispose and Recycle</div>
                        <div class="px-4 pt-6 mb-10 text-lg leading-snug text-white">At Atrex Services, we offer different types of disposal services. We take our disposal process very seriously as we understand how certain information and data can be sensitive.</div>
                        <div class="p-4 mb-4 text-white">
                            <table cellpadding="0" cellspacing="0" class="w-full text-base leading-snug text-white md:text-lg">
                                <tr>
                                    <td valign="top" width="25px"><img class="xl:ml-auto" src="/images/icon-check.png" /></td>
                                    <td class="pb-5 pl-3">Desktop computers</td>
                                </tr>
                                <tr>
                                    <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png" /></td>
                                    <td class="pb-5 pl-3">Laptops</td>
                                </tr>
                                <tr>
                                    <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png" /></td>
                                    <td class="pb-5 pl-3">Printers</td>
                                </tr>
                                <tr>
                                    <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png" /></td>
                                    <td class="pb-5 pl-3">Monitors</td>
                                </tr>
                                <tr>
                                    <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png" /></td>
                                    <td class="pb-5 pl-3">Hard disks</td>
                                </tr>
                                <tr>
                                    <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png" /></td>
                                    <td class="pb-5 pl-3">Circuit boards</td>
                                </tr>
                                <tr>
                                    <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png" /></td>
                                    <td class="pb-5 pl-3">Computer peripherals</td>
                                </tr>
                                <tr>
                                    <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png" /></td>
                                    <td class="pb-5 pl-3">Cameras</td>
                                </tr>
                                <tr>
                                    <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png" /></td>
                                    <td class="pb-5 pl-3">Mobile devices</td>
                                </tr>
                                <tr>
                                    <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png" /></td>
                                    <td class="pb-5 pl-3">Servers</td>
                                </tr>
                                <tr>
                                    <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png" /></td>
                                    <td class="pb-5 pl-3">Switches</td>
                                </tr>
                                <tr>
                                    <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png" /></td>
                                    <td class="pb-5 pl-3">And other general electronics</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ///////////////////////////////////////// OUR 4 icons START ///////////////////////////////////////// -->
        <div class="w-full mt-12 text-center md:flex">
            <div class="container flex flex-row items-center justify-between px-4 pt-6 mx-auto">
                <div class="w-1/5 lg:w-1/3 md:block title-line"></div>
                <div class="text-4xl font-bold leading-none text-blue-400 w-1/1 md:text-5xl title-text">Our Commitments &amp; Assurance!</div>
                <div class="w-1/5 lg:w-1/3 md:block title-line"></div>
            </div>
        </div>
        <div class="w-full section">
            <div class="container flex flex-wrap items-center justify-between px-4 pt-4 pb-2 mx-auto lg:pt-0">
                <div class="w-1/2 pr-2 mt-6 border-r-0 border-black lg:w-1/4 sm:border-r-0 lg:border-r-2">
                    <img src="images/icon-03.png" class="w-1/2 mx-auto h-1/1" />
                    <div class="mt-4 text-xl font-bold text-center lg:text-2xl">Compliance Certified<br />ISO 9001:2015<br />ISO 14001:2015<br />ISO 45001:2018</div>
                </div>
                <div class="w-1/2 pr-2 mt-6 border-r-0 border-black lg:w-1/4 sm:border-r-0 lg:border-r-2">
                    <img src="images/icon-02.png" class="w-1/2 mx-auto h-1/1" />
                    <div class="mt-4 text-xl font-bold text-center lg:text-2xl">Safe &amp;<br />Secure Disposal<br /><br /><br /></div>
                </div>
                <div class="w-1/2 pb-8 pr-2 mt-6 border-r-0 border-black lg:w-1/4 lg:pb-0 sm:border-r-0 lg:border-r-2">
                    <img src="images/icon-01.png" class="w-1/2 mx-auto h-1/1" />
                    <div class="mt-4 text-xl font-bold text-center lg:text-2xl">Accordance to<br />NEA standard<br /><br /><br /></div>
                </div>
                <div class="w-1/2 pb-8 pl-2 mx-auto lg:w-1/4 lg:pb-0">
                    <img src="images/icon-04.png" class="w-1/2 mx-auto mt-6 h-1/1" />
                    <div class="mt-4 text-xl font-bold text-center lg:text-2xl">Experience &amp;<br />Professional<br /><br /><br /></div>
                </div>
            </div>
        </div>
        <!-- ///////////////////////////////////////// OUR 4 icons END ///////////////////////////////////////// -->
        <!-- ///////////////////////////////////////// Ph section START ///////////////////////////////////////// -->
        <div class="py-8 bg-center bg-no-repeat bg-cover max-w-none bg-middle bg-img-01">
            <div class="container flex flex-wrap px-4 py-12 mx-auto lg:content-center">
                <div class="w-full px-6 py-2 bg-blue-800 border-4 border-blue-200 rounded-full lg:py-4">
                    <div class="font-bold text-center text-white text-1xl lg:text-3xl">
                        CALL US AT <a href="tel:+6567471910"><span class="text-2xl text-yellow-400 lg:text-4xl">6747 1910</span></a> TO GET AN INSTANT QUOTE!
                    </div>
                </div>
            </div>
        </div>
        <!-- ///////////////////////////////////////// Ph section END ///////////////////////////////////////// -->
        <div class="w-full mt-6 mb-8 section">
            <div class="container flex flex-col items-center justify-between px-4 pt-0 mx-auto lg:pt-0 lg:flex-row">
                <div class="w-full mx-auto lg:w-1/3">
                    <div class="title-text">
                        <div class="text-2xl font-bold leading-4 text-center lg:font-extrabold lg:text-3xl lg:text-left">About E-Waste Recycling</div>
                        <div class="text-3xl font-bold text-center lg:text-5xl lg:text-left leading-12">Need any</div>
                        <div class="text-3xl font-bold leading-10 text-center lg:text-5xl lg:text-left">help?</div>
                        <!-- <div class="text-5xl font-bold text-center lg:text-5xl lg:text-left leading-12"></div>  -->
                        <div class="py-6 mt-2 text-left text-gray-900 pr-none lg:pr-8 lg:text-left lg:mt-12">Do you have old fashioned computers kept in your storage area? Most business establishments are now using computers to transact faster and more efficiently provide the needs of their clients and contact their business partners and other stakeholders in the most convenient way. Malfunctions of your computers can affect your ability to communicate. Getting rid of your old computers can be a very tough task. Not to worry, Atrex Services can help you with your e-waste disposal and recycling needs!</div>
                    </div>
                </div>
                <div class="w-full px-10 py-10 mx-auto bg-gray-100 sm:w-full lg:w-1/3">
                    <div class="font-bold leading-none text-center text-gray-800"><span class="text-2xl lg:text-3xl">Request a</span><br /><span class="text-4xl font-extrabold lg:text-5xl">Free Quote</span></div>
                    <!-- feedback.activamedia.com.sg script begins here --><iframe allowTransparency="true" style="min-height: 620px; height: inherit; overflow: auto" width="100%" id="contactform123" name="contactform123" marginwidth="0" marginheight="0" frameborder="0" src="//feedback.activamedia.com.sg/my-contact-form-5979529.html"><p>Your browser does not support iframes. The contact form cannot be displayed. Please use another contact method (phone, fax etc)</p></iframe
                    ><!-- feedback.activamedia.com.sg script ends here -->
                </div>
                <div class="w-full pl-0 mx-auto sm:w-full md:w-full lg:w-1/3 lg:pl-8">
                    <img src="images/man.png" width="100%" />
                </div>
            </div>
        </div>
        <div class="bg-gray-300 section" id="testimonials">
            <div class="container">
                <div class="w-full mt-8 mb-12 text-3xl font-bold leading-none text-center text-gray-800 md:text-5xl">Strong Partnership. Proven Track Record</div>
                <div class="flex flex-wrap w-full">
                    <div class="w-1/2 pl-4 pr-4 mb-8 md:w-1/2 lg:w-1/4">
                        <img src="/images/tp-logo.png" />
                    </div>
                    <div class="w-1/2 pl-4 pr-4 mb-8 md:w-1/2 lg:w-1/4">
                        <img src="/images/sp-logo.png" />
                    </div>
                    <div class="w-1/2 pl-4 pr-4 mb-8 md:w-1/2 lg:w-1/4">
                        <img src="/images/rp-logo.png" />
                    </div>
                    <div class="w-1/2 pl-4 pr-4 mb-8 md:w-1/2 lg:w-1/4">
                        <img src="/images/np-logo.png" />
                    </div>
                    <div class="w-1/2 pl-4 pr-4 mb-8 md:w-1/2 lg:w-1/4">
                        <img src="/images/ngee-ann-logo.png" />
                    </div>
                    <div class="w-1/2 pl-4 pr-4 mb-8 md:w-1/2 lg:w-1/4">
                        <img src="/images/nus-logo.png" />
                    </div>
                    <div class="w-1/2 pl-4 pr-4 mb-8 md:w-1/2 lg:w-1/4">
                        <img src="/images/ntu-logo.png" />
                    </div>
                    <div class="w-1/2 pl-4 pr-4 mb-8 md:w-1/2 lg:w-1/4">
                        <img src="/images/st-engineering-logo.png" />
                    </div>
                </div>
                <!-- ///////////////////////////////////////// Ph section START ///////////////////////////////////////// -->
                <div class="mb-6 bg-center bg-no-repeat bg-cover max-w-none bg-middle">
                    <div class="container flex flex-wrap px-4 py-6 pt-6 mx-auto lg:content-center">
                        <div class="w-full px-6 py-2 bg-blue-800 border-4 border-blue-200 rounded-full lg:py-4">
                            <div class="font-bold text-center text-white text-1xl lg:text-3xl">
                                CALL US AT <a href="tel:+6567471910"><span class="text-2xl text-yellow-400 lg:text-4xl">6747 1910</span></a> TO GET AN INSTANT QUOTE!
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ///////////////////////////////////////// Ph section END ///////////////////////////////////////// -->
            </div>
        </div>
        <div class="w-full about-bg lg:flex">
            <div class="w-full lg:w-12/12">
                <img class="w-full h-full xl:ml-auto" src="/images/about-img.jpg" />
            </div>
            <div class="flex items-center justify-center w-full pt-12 pb-12 lg:w-12/12 lg:pt-0 lg:pb-0">
                <div class="w-full py-6 pl-3 pr-3 xl:w-9/12 lg:pl-6 lg:pr-6 lg:m-auto xl:pl-3">
                    <div class="w-full mb-12 text-3xl font-bold leading-10 text-gray-800 md:text-5xl lg:leading-12">
                        <div class="text-2xl md:text-3xl">About Us</div>
                        Atrex Services
                    </div>
                    <div class="text-lg leading-snug text-gray-800">
                        <p>
                            Established in 2003, our goal has always been to be our clients’ number one IT Solutions provider. We want to provide only the best of qualities and services, keeping them satisfied.
                            <br /><br />
                            Over the years, we’ve managed to get different types of certifications necessary to show our clients that we are a trustworthy company that they can rely on.
                            <br /><br />
                            We spent the last 15 years doing so and we are going to continue to doing so because We Make IT Happen.
                            <br /><br />
                            Atrex Services has successfully completed the Awareness &amp; Internal Auditor Training on: ISO 9001:2015|ISO 14001:2015|ISO 45001:2018
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full section-t">
            <div class="container px-4">
                <div class="w-full lg:flex lg:items-center lg:justify-center">
                    <div class="w-full text-center lg:w-3/6">
                        <img class="pb-6 m-auto" src="/images/logo-painting.png" />
                        <!-- <div class="pb-10 text-2xl font-bold leading-snug text-gray-800 md:text-3xl">
                          Atrex Services Pte Ltd
                        </div> -->
                        <div class="text-base leading-snug text-gray-800 md:text-lg">
                            <strong>Singapore Office (HQ)</strong><br />
                            38 Kaki Bukit Crescent #01-00, Singapore 416265<br />
                            <a href="tel:+6567471910">+65 67471910</a> / <a href="tel:+6594363876">94363876</a><br />
                            <a href="mailto:rinus@atrexservices.com">rinus@atrexservices.com</a><br /><br />
                            <strong>Malaysia Office</strong><br />
                            810 Kampung Chempaka, Jalan PJU 1/11, 47301 PJ, Malaysia<br />
                            <a href="tel:+60378807601">+603 7880 7601</a> / <a href="tel:+60378031309">+603 7803 1309</a><br />
                            <a href="mailto:rinus@atrexservices.com">rinus@atrexservices.com</a>
                            <!-- 52 Ubi Ave 3, Frontier #01-48<br/>Singapore 408867<br/>
                            Tel: <a href="tel:+6567471910">(+65) 6747 1910</a>  |  E-mail: <a href="mailto:Sales@AtrexServices.com">Sales@AtrexServices.com</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full pt-5 pb-8 bg-white border-t-2 border-gray-300">
            <div class="container px-4 pt-6 text-center">
                <div class="w-full text-sm text-gray-800">Website maintained by Activa Media. All right reserved.</div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.btn-wa {
    background-color: #f2f2f2;
    border-radius: 100%;
    position: fixed;
    padding: 8px;
    bottom: 15px;
    right: 15px;
    z-index: 100;
}
</style>

<script>
import carousel from "vue-owl-carousel";
import vueSmoothScroll from "vue-smooth-scroll";
export default {
    components: {
        vueSmoothScroll,
        carousel,
    },
};
</script>
